<main>
  @if (authorized) {
    <router-outlet></router-outlet>
  }
</main>
